import { LinkButton, UIHeading2, UIText1 } from '@cian/ui-kit';
import * as React from 'react';
import { ContentWrapper } from '../../components/ContentWrapper';
import { LandingBlock } from '../../components/LandingBlock';
import * as styles from './SupportBlock.css';
import cn from 'classnames';
import { MORTGAGE_LINK } from '../../constants/suburban';

export const SupportBlock = () => {
  return (
    <LandingBlock>
      <ContentWrapper>
        <div className={styles['container']}>
          <div className={cn(styles['block'], styles['image-block'])} />
          <div className={cn(styles['block'], styles['gradient'])}>
            <div className={styles['inner']}>
              <div className={styles['header']}>
                <UIHeading2 fontWeight="700">Остались вопросы?</UIHeading2>
              </div>
              <div className={styles['text']}>
                <UIText1>Все вопросы по сервису и заполнению анкеты можно задать здесь</UIText1>
              </div>
              <div className={styles['phone']}>
                <UIHeading2 fontWeight="700">8 800 551-34-42</UIHeading2>
              </div>
              <a href="mailto:ipoteka@cian.ru" className={styles['email-link']}>
                <UIText1 color="primary_100">ipoteka@cian.ru</UIText1>
              </a>
            </div>
          </div>
          <div className={cn(styles['block'], styles['gradient'])}>
            <div className={styles['inner']}>
              <div className={styles['header']}>
                <UIHeading2 fontWeight="700">Циан.Ипотека</UIHeading2>
              </div>
              <div className={styles['text']}>
                <UIText1>Ваши реальные ипотечные ставки. Одна анкета — 8 банков.</UIText1>
              </div>
              <LinkButton theme="fill_primary" size="L" href={MORTGAGE_LINK} target="_blank">
                Узнать свои льготные ставки
              </LinkButton>
            </div>
          </div>
        </div>
        <UIText1 color="gray60_100">* по дальневосточной программе господдержки</UIText1>
      </ContentWrapper>
    </LandingBlock>
  );
};
